import { Page } from "@cntrl/ui";
import { RequireBand } from "../../app/RequireBand.js";
import { CaseChecklist } from "../roadCases/CaseChecklist.js";

/**
 * `/road-cases` — the road cases as a page: the same `CaseChecklist` the mobile home card renders (states, scan mode,
 * reset, the case sheet with items and the sticker), so the two cannot disagree (ART-253).
 */
export function RoadCasesScreen() {
  return (
    <RequireBand>
      <Page title="Road cases">
        <CaseChecklist />
      </Page>
    </RequireBand>
  );
}
